<template>
  <main id="app" class="h-full" data-app>
    <router-view></router-view>
  </main>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { loadMsClarityScript } from '@/utils/ms-clarity';
@Component
export default class App extends Vue {
  mounted() {
    this.initializeMsClarity();
  }
  private initializeMsClarity() {
    if (process.env.VUE_APP_MODE === 'dev') return;
    loadMsClarityScript();
  }
}
</script>
